import { FC } from 'react';
import CraftCtaSidebar from './CraftCtaSidebar';
import CraftCtaSidebarDownload from './CraftCtaSidebarDownload';
import CraftSidebarCallout from './CraftSidebarCallout';
import CraftSidebarMedia from './CraftSidebarMedia';
import CraftSidebarRelated from './CraftSidebarRelated';

interface BlogSidebarRendererProps {
  blocks: any[];
}

const renderBlock = (block: any, index: number) => {
  switch (block.__typename) {
    case 'blogSidebarModules_ctaSidebar_BlockType':
      return <CraftCtaSidebar key={index} block={block} />;
    case 'blogSidebarModules_ctaSidebarDownload_BlockType':
      return <CraftCtaSidebarDownload key={index} block={block} />;
    case 'blogSidebarModules_sidebarCallout_BlockType':
      return <CraftSidebarCallout key={index} block={block} />;
    case 'blogSidebarModules_sidebarMedia_BlockType':
      return <CraftSidebarMedia key={index} block={block} />;
    case 'blogSidebarModules_sidebarRelated_BlockType':
      return <CraftSidebarRelated key={index} block={block} />;
    default:
      return null;
  }
};

const BlogSidebarRenderer: FC<BlogSidebarRendererProps> = ({ blocks }) => {
  if (!blocks || blocks.length === 0) return null;

  return (
    <div className="flex flex-col gap-6">
      {blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
};

export default BlogSidebarRenderer;
